/** Error names treated as durable-storage failures and converted to fallback results. */
const STORAGE_FAILURE_ERROR_NAMES = new Set([
  'AbortError',
  'DatabaseClosedError',
  'InvalidStateError',
  'MissingAPIError',
  'NoSuchDatabaseError',
  'NotFoundError',
  'NotReadableError',
  'OpenFailedError',
  'QuotaExceededError',
  'SecurityError',
  'UnknownError',
  'VersionError',
]);

/** Returns whether an error or nested cause has a known durable-storage failure name. */
export function isStorageFailure(error: unknown, seen = new Set<unknown>()): boolean {
  if (!error || seen.has(error)) return false;
  seen.add(error);

  const name = errorName(error);
  if (name && STORAGE_FAILURE_ERROR_NAMES.has(name)) return true;

  if (typeof error === 'object') {
    // SAFETY: Wrapped storage errors may expose optional cause/inner fields; each value is re-checked as unknown recursively.
    const wrapped = error as { readonly cause?: unknown; readonly inner?: unknown };
    return isStorageFailure(wrapped.inner, seen) || isStorageFailure(wrapped.cause, seen);
  }

  return false;
}

function errorName(error: unknown): string | undefined {
  if (!error || typeof error !== 'object' || !('name' in error)) return undefined;
  return typeof error.name === 'string' ? error.name : undefined;
}
